import { type ComponentType, type ReactNode } from 'react';
import { LuSparkle } from 'react-icons/lu';
import { RiEditLine, RiStethoscopeLine } from 'react-icons/ri';

type IconComponent = ComponentType<{ size: number; className: string }>;

const agentIconMap: Record<string, IconComponent> = {
  pulse: RiStethoscopeLine,
  study_protocol_parser: RiEditLine,
};

/**
 * Returns the icon element associated with an agent slug.
 * Falls back to a sparkle icon for unrecognized slugs.
 */
export const getAgentIcon = (slug: string): ReactNode => {
  const Icon = agentIconMap[slug] ?? LuSparkle;
  return <Icon size={26} className="blue" />;
};
